import { render, staticRenderFns } from "./PdfEditorTest.vue?vue&type=template&id=2001f2e2&"
import script from "./PdfEditorTest.vue?vue&type=script&lang=js&"
export * from "./PdfEditorTest.vue?vue&type=script&lang=js&"
import style0 from "./PdfEditorTest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PdfEditorTest.vue?vue&type=style&index=1&lang=scss&"
import style2 from "../../assets/tailwind.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports